var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',_vm._l((_vm.quantity),function(index){return _c('b-list-group-item',{key:`campaign-loading-${index}`},[_c('b-skeleton',{attrs:{"width":"100%"}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }